var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconlyBoldTickSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.63,
    height: 21.63,
    viewBox: "0 0 21.63 21.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Bold_Tick-Square",
    "data-name": "Iconly/Bold/Tick-Square",
    transform: "translate(-0.925 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-dropdown-circle",
    "data-name": "Icon ionic-ios-arrow-dropdown-circle",
    d: "M3.375,14.19A10.815,10.815,0,1,0,14.19,3.375,10.813,10.813,0,0,0,3.375,14.19Zm15.032-2.257a1.007,1.007,0,0,1,1.419,0,.991.991,0,0,1,.291.707,1.009,1.009,0,0,1-.3.712l-4.9,4.888a1,1,0,0,1-1.383-.031l-4.976-4.96a1,1,0,0,1,1.419-1.419L14.2,16.088Z",
    transform: "translate(-2.45 -1.375)",
    fill: "#4671a4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconlyBoldTickSquare);
export default __webpack_public_path__ + "static/media/Iconly-Bold-Tick-Square.6b158394f5075ca20c5f97fc3b71adcf.svg";
export { ForwardRef as ReactComponent };